import { useRef } from 'react';

import { FAQ } from '@components/FAQ';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupIpWhatsNotCoveredClicked } from '@tracking/trackingEvents';

import { topics } from './topics';

const mappedTopics = topics.map((topic) => ({
  ...topic,
  question: topic.title,
  answer: topic.details,
}));

const sections = [
  {
    id: 'root',
    title: '',
    topics: mappedTopics,
  },
];

const NotCovered = () => {
  const ref = useRef(null);

  const { trackingContexts } = useTrackingContext();
  const trackExpanded = useTrackSignupIpWhatsNotCoveredClicked();

  const handleAccordionChange = (feature: string, isExpanded: boolean) => {
    if (!isExpanded) {
      return;
    }

    trackExpanded(
      {
        policy_feature: feature,
      },
      { contexts: trackingContexts }
    );
  };

  return (
    <FAQ
      ref={ref}
      sections={sections}
      showTitle={false}
      onAccordionChange={handleAccordionChange}
      embed
    />
  );
};

export { NotCovered };
